const NoResults = ({ text }) => (
  <div className="min-h-[400px]">
    <p className="font-alliance-medium text-[24px] lg:text-[40px] text-blue opacity-50 flex mt-20">
      {text || 'No hi ha resultats, prova una altra combinació'}
    </p>
  </div>
)

export default NoResults
